import { render } from "./TitleCont.vue?vue&type=template&id=f8e4aac8"
import script from "./TitleCont.vue?vue&type=script&lang=js"
export * from "./TitleCont.vue?vue&type=script&lang=js"

import "./TitleCont.vue?vue&type=style&index=0&id=f8e4aac8&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__